import formatDeployTime from 'helper/format-deploy-time'
import packageJson from '../../../../package.json'

export default [
  {
    key: '1',
    last_deployed: formatDeployTime(),
    version: packageJson.version
  }
]
